<template>
  <div class="logistics">
    <div class="title">物流信息</div>
    <div class="section" v-for="section in logistics">
      <!--      {{ section }}-->
      <div class="item">
        <div class="label">物流状态：</div>
        <div class="text">{{ section.express.statusText }}</div>
      </div>
      <div class="item">
        <div class="label">快递公司：</div>
        <div class="text">{{ section.express.expressName }}</div>
      </div>
      <div class="item">
        <div class="label">运单号码：</div>
        <div class="text copy-text">
          {{ section.express.expressNo }}
          <div class="copy" @click="copy(section.express.expressNo)">复制</div>
        </div>
      </div>
      <div class="item">
        <div class="label">物流跟踪：</div>
        <div class="text">
          <div class="line-message" v-for="i in section.list">{{ i.time }} {{ i.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { copy } from '@/utils'
export default {
  props: ['logistics'],
  methods: {
    copy(t) {
      copy(t)
    }
  }
}
</script>
<style lang="scss" scoped>
.logistics {
  margin-top: 16px;
  padding: 0 24px;
  .title {
    font-weight: 400;
    color: #262626;
    line-height: 20px;
    font-size: 12px;
    margin-bottom: 12px;
  }
  @mixin baseitem {
    display: flex;
    margin-bottom: 12px;
    justify-content: flex-start;
    .label {
      font-size: 12px;
      color: #8c8c8c;
    }
    .text {
      flex: 1;
      flex-wrap: wrap;
      font-size: 12px;
      color: #262626;
      line-height: 18px;

      img {
        width: 48px;
        height: 48px;
        margin-right: 8px;
      }
      .line-message {
        margin-bottom: 12px;
        color: #333333;
        line-height: 14px;
      }
    }
  }
  .section {
    margin-top: 16px;
    .copy-text {
      display: flex;
      .copy {
        margin-left: 12px;
        font-size: 12px;
        color: #1e8dff;
        cursor: pointer;
      }
    }
    .item {
      @include baseitem;
    }
  }
}
</style>
